/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["div#filter[_ngcontent-%COMP%]{position:relative;top:-1.1rem}div#filter-criteria.show[_ngcontent-%COMP%]{margin-top:1.1rem;transition:all ease-in-out .5s;-webkit-transition:.5s ease-in-out;-moz-transition:.5s ease-in-out}div#filter-button[_ngcontent-%COMP%]{background-color:#fff}div#filter-button[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{border-top-left-radius:0;border-top-right-radius:0}button[data-toggle=tooltip][_ngcontent-%COMP%]   i[_ngcontent-%COMP%]{color:#000;font-size:1.5em;padding-left:0!important}"];
export { styles as styles };
